"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateFromRate = calculateFromRate;
const decimal_js_1 = require("decimal.js");
function calculateFromRate(amount, percentage, minimum) {
    if (percentage.equals(0) || amount === 0) {
        return 0;
    }
    const rate = percentage.div(100);
    const value = rate.mul(amount).toDecimalPlaces(0, decimal_js_1.Decimal.ROUND_UP).toNumber();
    return minimum && value < minimum ? minimum : value;
}
